import { useMediaQuery } from 'usehooks-ts';

import { cn } from '@/utils/cn';

import { renderValue } from '../utils';

interface DisplayCardProps {
  title: string;
  value: number | string | null;
  isBorder?: boolean;
  width?: number;
  icon?: React.ReactNode;
}

const DisplayCard: React.FC<DisplayCardProps> = ({ title, value, isBorder = false, width = 190, icon = null }: DisplayCardProps) => {
  const isXl = useMediaQuery('(min-width: 1280px)');

  return (
    <div className='flex flex-col h-full'>
      <div className='flex flex-1 flex-col overflow-hidden'>
        <div
          className={cn(
            'flex flex-1 flex-col py-4 px-6 rounded-2xl',
            isBorder ? 'border-2 border-border-primary bg-surface-primary pl-[60px]' : 'bg-surface-secondary',
            isXl && `min-w-[${width}px]`,
          )}
        >
          <p className='text-xl text-text-secondary'>{title}</p>
          <div className='flex items-center gap-2'>
            <p className='text-xl font-semibold text-text-primary leading-[25px]'>{renderValue(value, icon)}</p>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayCard;
